import { render, staticRenderFns } from "./DataStudioDashboard.vue?vue&type=template&id=5b7bbfec&scoped=true&lang=pug"
import script from "./DataStudioDashboard.vue?vue&type=script&lang=js"
export * from "./DataStudioDashboard.vue?vue&type=script&lang=js"
import style0 from "./DataStudioDashboard.vue?vue&type=style&index=0&id=5b7bbfec&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7bbfec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b7bbfec')) {
      api.createRecord('5b7bbfec', component.options)
    } else {
      api.reload('5b7bbfec', component.options)
    }
    module.hot.accept("./DataStudioDashboard.vue?vue&type=template&id=5b7bbfec&scoped=true&lang=pug", function () {
      api.rerender('5b7bbfec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DataStudioDashboard.vue"
export default component.exports